function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 5.3h-11v1.5l3.5 5.7-3.5 5.7v1.5h11v-1.5H8.3l3.6-5.7-3.6-5.7h9.2V5.3z",
  fill: "#111"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 5.3H16v3.3h1.5V5.3zM17.5 16.4H16v3.3h1.5v-3.3z",
  fill: "#111"
});

function SvgFormulaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgFormulaIcon;